// extracted by mini-css-extract-plugin
export default {"place-card__type--text":"card-place_place-card__type--text__vqs1j"};